<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>
<script>
  import store from './store/'
  export default {
    name: 'app'
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";

  #app {
    height: 100%;
  }

  .main {
    background-color: #f5f5f5;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5305ef7b